// extracted by mini-css-extract-plugin
export default {"root":"CTA_root__Pt3in"};